import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: 'Catálogo',
    component: () =>
      import(/* webpackChunkName: "home" */ "../components/Catalogo"),
  },
  {
    path: "/:filter(menorPrecio|mayorPrecio|alfabetico|masNuevo)",
    name: 'Catálogo ordenado',
    params: true,
    component: () =>
      import(/* webpackChunkName: "home" */ "../components/Catalogo"),
  },
  {
    path: "/preventas",
    name: 'Preventas',
    component: () =>
      import(/* webpackChunkName: "catalogo" */ "../components/Preventas"),
  },
  {
    path: "/descuentos",
    name: 'Descuentos',
    params: true,
    component: () =>
      import(/* webpackChunkName: "catalogo" */ "../components/pages/Descuentos"),
  },
  {
    path: "/promo-200",
    name: 'Promo 200',
    params: true,
    component: () =>
      import(/* webpackChunkName: "catalogo" */ "../components/pages/Promo3x200"),
  },
  // {
  //   path: "/puntosEntrega",
  //   name: 'Entrega',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "agregarNuevoPop" */ "../components/pages/PuntosEntrega"
  //     ),
  // },
  {
    path: "/encuestas",
    name: 'Encuestas',
    component: () =>
      import(
        /* webpackChunkName: "agregarNuevoPop" */ "../components/Encuestas"
      ),
  },
  {
    //path: "/encuestas/encuesta/:id",
    path: "/encuestas/encuesta/:id",
    name: "encuesta",
    params: true,
    component: () =>
      import(/* webpackChunkName: "pop" */ "../components/pages/Encuesta"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
